// extracted by mini-css-extract-plugin
export default {"categories":"Categories_categories__Kifn3","dmcategoriesPage":"Categories_dmcategoriesPage__HTsaD","dmcategories":"Categories_dmcategories__zITBC"};